import script from "./SmallButton.vue?vue&type=script&setup=true&lang=js"
export * from "./SmallButton.vue?vue&type=script&setup=true&lang=js"

import "./SmallButton.vue?vue&type=style&index=0&id=e64abc34&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e64abc34"]])

export default __exports__